import React, { useEffect } from 'react';
import './PriceOverlay.scss';
import { Button, EButtonType, Input, KitIcons } from '@repo/apg-ui';

interface Props {
  priceLabels?: string;
  placeholderText?: string;
  inputValue: any;
  onChange?: any;
  isDisabled?: boolean;
}

export const PriceOverlay = ({ isDisabled, placeholderText, priceLabels, inputValue, onChange }: Props) => {
  const [budget, setBudget] = React.useState<number>(inputValue);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setBudget(parseFloat(event.target.value) || 0);
      onChange(parseFloat(event.target.value) || 0);
    }
  };

  useEffect(() => {
    setBudget(inputValue);
  }, [inputValue]);
  if (isDisabled) return null;

  return (
    <div className='overlay-content price-block' id='root'>
      <div className='d-flex align-items-start justify-content-start gap-3 w-100'>
        <div className='d-flex flex-column position-relative align-items-start justify-content-start'>
          <div className='subtitle'>{priceLabels || 'Price'}</div>
          <div className='d-flex align-items-center justify-content-center gap-3'>
            <div className='input-wrap'>
              <Input
                value={budget}
                name={'price-input'}
                type='text'
                placeholder={placeholderText || 'Price'}
                onChange={(name, _value) => {
                  setBudget(_value);
                }}
                onKeyDown={handleKeyDown}
                inputWrapperClass='mt-0 p-0 price-input'
              />
              <span className='input-label'>CHF</span>
            </div>
            <div className='input-action'>
              <Button
                buttonType={EButtonType.PillSmall}
                onClick={() => {
                  onChange(budget);
                }}
              >
                <div className='button-svg'>
                  <KitIcons.CheckIcon className='check-svg' />
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
